import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Image as ImageIcon } from "lucide-react";
import Layout from "../components/Layout";
import { api, formatApiErrorDetail } from "../lib/api";

const STATUS = { new: ["Nieuw", "bg-emerald-100 text-emerald-800"], in_progress: ["In behandeling", "bg-amber-100 text-amber-800"], done: ["Afgehandeld", "bg-slate-100 text-slate-600"] };

export default function AdminFeedback() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("open");
  const [err, setErr] = useState("");
  const [shot, setShot] = useState(null);
  const load = () => api.get("/admin/feedback").then((r) => setItems(r.data)).catch((e) => setErr(formatApiErrorDetail(e?.response?.data?.detail)));
  useEffect(() => { load(); }, []);
  const setStatus = async (f, status) => { await api.put(`/admin/feedback/${f.id}`, { status }); setItems((xs) => xs.map((x) => (x.id === f.id ? { ...x, status } : x))); };
  const openShot = async (f) => { const { data } = await api.get(`/admin/feedback/${f.id}/screenshot`); setShot(data.screenshot_base64); };
  const shown = items.filter((f) => (filter === "all" ? true : filter === "open" ? (f.status || "new") !== "done" : (f.status || "new") === filter));
  if (err) return <Layout title="Feedback"><div className="text-sm text-rose-600" data-testid="admin-feedback-error">{err}</div></Layout>;
  return (
    <Layout title="Feedback" subtitle="Admin · ingestuurde feedback" right={<Link to="/admin" className="text-xs underline text-slate-500" data-testid="admin-feedback-back">Admin</Link>}>
      <div className="space-y-4" data-testid="admin-feedback-page">
        <div className="text-xs text-slate-500">Opslag: collectie <code>feedback</code> · e-mail naar <b>support@play-maker.eu</b> bij elke nieuwe melding.</div>
        <div className="flex gap-1 p-1 rounded-xl bg-slate-100 w-fit" data-testid="admin-feedback-filter">
          {[["open", "Open"], ["new", "Nieuw"], ["in_progress", "In behandeling"], ["done", "Afgehandeld"], ["all", "Alles"]].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setFilter(k)} className={`h-9 px-3 rounded-lg text-xs font-semibold ${filter === k ? "bg-white shadow-sm text-slate-900" : "text-slate-500"}`} data-testid={`admin-feedback-filter-${k}`}>{l}</button>
          ))}
        </div>
        {shown.length === 0 && <div className="pm-card p-5 text-sm text-slate-500" data-testid="admin-feedback-empty">Geen feedback in deze categorie.</div>}
        <div className="space-y-3">
          {shown.map((f) => {
            const [label, tone] = STATUS[f.status || "new"] || STATUS.new;
            return (
              <div key={f.id} className="pm-card p-4 space-y-2" data-testid={`admin-feedback-item-${f.id}`}>
                <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
                  <span className={`px-2 py-0.5 rounded-full font-semibold ${tone}`} data-testid="admin-feedback-status">{label}</span>
                  <span className="font-semibold text-slate-900">{f.user_name}</span><span>({f.role})</span>
                  {f.workspace_name && <span>· {f.workspace_name}</span>}
                  <span>· {f.page || "-"}</span><span>· {f.device || "-"}</span>
                  <span>· {(f.created_at || "").slice(0, 16).replace("T", " ")}</span>
                  {f.notified && <span className="text-slate-400">· mail: {f.notified}</span>}
                </div>
                <div className="text-sm whitespace-pre-wrap">{f.message}</div>
                <div className="flex flex-wrap items-center gap-2">
                  <select className="pm-input h-9 text-xs w-auto" value={f.status || "new"} onChange={(e) => setStatus(f, e.target.value)} data-testid="admin-feedback-status-select">
                    <option value="new">Nieuw</option><option value="in_progress">In behandeling</option><option value="done">Afgehandeld</option>
                  </select>
                  {f.has_screenshot && <button type="button" onClick={() => openShot(f)} className="pm-btn-secondary h-9 px-3 rounded-lg text-xs flex items-center gap-1" data-testid="admin-feedback-screenshot"><ImageIcon size={13} /> Screenshot</button>}
                  <a href={`mailto:${f.user_email}`} className="text-xs underline text-slate-500">{f.user_email}</a>
                </div>
              </div>
            );
          })}
        </div>
        {shot && (
          <div className="fixed inset-0 z-[90] bg-black/70 flex items-center justify-center p-4" onClick={() => setShot(null)} data-testid="admin-feedback-screenshot-modal">
            <img src={shot} alt="Screenshot" className="max-h-[90vh] max-w-full rounded-xl shadow-2xl" />
          </div>
        )}
      </div>
    </Layout>
  );
}
